// src/utils/dateUtils.js

/**
 * 日時を分まで表示するフォーマット関数（秒数なし）
 * @param {Date|Object|string} timestamp - フォーマットする日時
 * @returns {string} フォーマットされた日時文字列
 */
export const formatDateTimeToMinute = (timestamp) => {
    if (!timestamp) return '未設定';

    let date;
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
        date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
        date = timestamp;
    } else if (typeof timestamp === 'string') {
        date = new Date(timestamp);
    } else {
        return '無効な日時';
    }

    // 秒数なしで日時をフォーマット
    return date.toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
};

/**
 * 日付のみを表示するフォーマット関数
 * @param {Date|Object|string} timestamp - フォーマットする日時
 * @returns {string} フォーマットされた日付文字列
 */
export const formatDateOnly = (timestamp) => {
    if (!timestamp) return '未設定';

    let date;
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
        date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
        date = timestamp;
    } else if (typeof timestamp === 'string') {
        date = new Date(timestamp);
    } else {
        return '無効な日時';
    }

    // 日付のみをフォーマット
    return date.toLocaleDateString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
};

/**
 * 時間のみを表示するフォーマット関数（秒数なし）
 * @param {Date|Object|string} timestamp - フォーマットする日時
 * @returns {string} フォーマットされた時間文字列
 */
export const formatTimeToMinute = (timestamp) => {
    if (!timestamp) return '未設定';

    let date;
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
        date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
        date = timestamp;
    } else if (typeof timestamp === 'string') {
        date = new Date(timestamp);
    } else {
        return '無効な日時';
    }

    // 時間のみをフォーマット（秒数なし）
    return date.toLocaleTimeString('ja-JP', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
}; 